import { DateTimeFormatter, Duration, ZonedDateTime } from '@js-joda/core';

export function toLocaleDateStringWithHoursAndMinutes(date: string | number) {
  return new Date(date).toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  });
}

export const parseTimestamp = (timestamp: string) => {
  // The format returned from the server
  return ZonedDateTime.parse(timestamp, DateTimeFormatter.ISO_OFFSET_DATE_TIME);
};

// eslint-disable-next-line complexity
export const ago = (date: string) => {
  const duration = Duration.between(parseTimestamp(date), ZonedDateTime.now());

  if (duration.isNegative()) {
    if (duration.toDays() < -365 * 2) {
      return `in ${Math.round(duration.toDays() / -365)} years`;
    } else if (duration.toDays() < -365) {
      return `in 1 year`;
    } else if (duration.toDays() < -30 * 2) {
      return `in ${Math.round(duration.toDays() / -30)} months`;
    } else if (duration.toDays() < -30) {
      return `in 1 month`;
    } else if (duration.toDays() < -7 * 2) {
      return `in ${Math.round(duration.toDays() / -7)} weeks`;
    } else if (duration.toDays() < -7) {
      return `in 1 week`;
    } else if (duration.toDays() < -1 * 2) {
      return `in ${Math.round(duration.toDays() / -1)} days`;
    } else if (duration.toDays() < -1) {
      return `in 1 day`;
    } else if (duration.toHours() < -1 * 2) {
      return `in ${Math.round(duration.toHours() / -1)} hours`;
    } else if (duration.toHours() < -1) {
      return `in 1 hour`;
    } else if (duration.toMinutes() < -1 * 2) {
      return `in ${Math.round(duration.toMinutes() / -1)} minutes`;
    } else if (duration.toMinutes() < -1) {
      return `in 1 minute`;
    }
  }

  if (duration.toDays() >= 365 * 2) {
    return `${Math.floor(duration.toDays() / 365)} years ago`;
  } else if (duration.toDays() > 365) {
    return `1 year ago`;
  } else if (duration.toDays() >= 30 * 2) {
    return `${Math.floor(duration.toDays() / 30)} months ago`;
  } else if (duration.toDays() >= 30) {
    return `1 month ago`;
  } else if (duration.toDays() >= 7 * 2) {
    return `${Math.floor(duration.toDays() / 7)} weeks ago`;
  } else if (duration.toDays() >= 7) {
    return `1 week ago`;
  } else if (duration.toDays() > 1) {
    return `${duration.toDays()} days ago`;
  } else if (duration.toDays() === 1) {
    return `1 day ago`;
  } else if (duration.toHours() > 1) {
    return `${duration.toHours()} hours ago`;
  } else if (duration.toHours() === 1) {
    return `1 hour ago`;
  } else if (duration.toMinutes() > 1) {
    return `${duration.toMinutes()} minutes ago`;
  } else if (duration.toMinutes() === 1) {
    return `1 minute ago`;
  }

  return `Just now`;
};
